import PureLoadable from 'react-17-pure-loadable';

const AuthErrorPage = PureLoadable({
  loader: () => import('./AuthErrorPage.jsx'),
  displayName: 'AuthErrorPage',
});

export default AuthErrorPage;
